import {
  DELETE_COMPANY_REQUEST,
  DELETE_COMPANY_ERROR,
  DELETE_COMPANY_SUCCESS,
  TOKEN_EXPIRED
} from '../types';
import context from "../common/deleteEntity"
import RESOURCES from '../../api/resources';

const initialState = {};
export default entity => (state = initialState, action) => {

  context.init(context);

  context.DELETE_ENTITY_REQUEST = DELETE_COMPANY_REQUEST;
  context.DELETE_ENTITY_ERROR = DELETE_COMPANY_ERROR;
  context.DELETE_ENTITY_SUCCESS = DELETE_COMPANY_SUCCESS;
  context.TOKEN_EXPIRED = TOKEN_EXPIRED;

  context.entityName = "company";
  context.entityLocation = RESOURCES.Companies;

  return context.execute(context)(entity)(state, action);
};